<app-data-table-manager
  [columnConfigs]="columnConfigs"
  [filterConfig]="DEFAULT_FILTER_CONFIG"
  [tableData]="tableData"
  [fieldFilters]="fieldFilters"
  [displayInfo]="displayInfo"
  [domainMarketLang]="domainMarketLang"
  [facetGroups]="facetGroups"
  [elementStyles]="elementStyles"
  [forceReloadData]="forceReloadData"
  [tableName]="'commentsModeration'"
  [defaultSortActive]="defaultSortActive"
  [defaultSortDirection]="defaultSortDirection"
  (emitAction)="handleAction($event)"
  (loadDataRequested)="loadComments($event)"
  (needToReloadData)="handleReloadData($event)"
  (selectionChanged)="onSelectionChanged($event)"
>
  <div moderateButtons>
    <div class="moderate-buttons">
      <button
        mat-raised-button
        class="btn-default"
        (click)="handleCommentAction(selection, CommentAction.DELETE)"
        [disabled]="!this.selection.hasValue()"
      >
        {{ 'COMMENTS.SEARCH.BTN.BATCH_DELETE' | translate }}
      </button>
      <button
        mat-raised-button
        class="btn-danger"
        (click)="handleCommentAction(selection, CommentAction.REJECT)"
        [disabled]="isButtonDisabled"
      >
        {{ 'COMMENTS.SEARCH.BTN.BATCH_REJECT' | translate }}
      </button>
      <button
        mat-raised-button
        class="btn-approve"
        (click)="handleCommentAction(selection, CommentAction.APPROVE)"
        [disabled]="isButtonDisabled"
      >
        {{ 'COMMENTS.SEARCH.BTN.BATCH_APPROVE' | translate }}
      </button>
    </div>
  </div>
  <app-filter-domain-market-lang
    [domainMarketLang]="domainMarketLang"
    [fieldsFilterDomainMarketLang]="fieldsFilterDomainMarketLang"
    (filterChange)="handleGlobalFilterChange($event)"
  ></app-filter-domain-market-lang>
</app-data-table-manager>
